import * as React from "react";

import "./Congrats.css";

interface CongratsProps {}

const successImage = require("../assets/highfive.png");

// TODO: probably an image + background image on the text
const Congrats = (props: CongratsProps) =>
  <section className="order-success-congrats">
    <div className="order-success-congrats__bubble">
      <div className="order-success-congrats__text">
        <p>Chúc mừng</p>
        <p>Bạn đã đặt hàng thành công</p>
      </div>
    </div>
    <div className="order-success-congrats__img-container">
      <img className="img-responsive" src={successImage} />
    </div>
  </section>;

export default Congrats;



// WEBPACK FOOTER //
// ./src/routes/OrderSuccess/components/Congrats.tsx